"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleUserSearchModel = instanceOfRoleUserSearchModel;
exports.RoleUserSearchModelFromJSON = RoleUserSearchModelFromJSON;
exports.RoleUserSearchModelFromJSONTyped = RoleUserSearchModelFromJSONTyped;
exports.RoleUserSearchModelToJSON = RoleUserSearchModelToJSON;
exports.RoleUserSearchModelToJSONTyped = RoleUserSearchModelToJSONTyped;
/**
 * Check if a given object implements the RoleUserSearchModel interface.
 */
function instanceOfRoleUserSearchModel(value) {
    return true;
}
function RoleUserSearchModelFromJSON(json) {
    return RoleUserSearchModelFromJSONTyped(json, false);
}
function RoleUserSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'uId': json['uId'] == null ? undefined : json['uId'],
        'uName': json['uName'] == null ? undefined : json['uName'],
        'uOid': json['uOid'] == null ? undefined : json['uOid'],
    };
}
function RoleUserSearchModelToJSON(json) {
    return RoleUserSearchModelToJSONTyped(json, false);
}
function RoleUserSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'uId': value['uId'],
        'uName': value['uName'],
        'uOid': value['uOid'],
    };
}
